import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Tab, Grid, Table } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import { lpcoEnvs, lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn";
import {
    useForm,
    useFetch,
    useGrid,
    useResource,
    usePopup,
    useStore,
    useToast,
    useAuth,
    useModal,
    useTab,
    usePage,
} from "@/comn/hooks";
import {
    BASE,
    URLS,
    APIS,
    SF_SCHEMA_LPCO_FEE_FORM,
    SG_GFS_ITM_LIST,
} from "@/tz/go/egaz/osci/lpco/fee/services/OsciLpcoFeeService";

/*
 * Details Payment history information
 * !== 납부 내역 정보 상세 화면 ==!
 */
export const OSCI0205006S = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    // const pgeTitle = "Paid Records Details"; // Page Title !== 페이지 타이틀 ==!
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0006", "auth_osci0008", "auth_osci0009", "auth_osci0021", "auth_osci0003"],
    });

    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!
    const { uuid } = useParams(); // Key Information of this Component Router !== 라우터에 정의된 키정보 ==!

    const [vsdItms, setVsdItms] = useState(false);
    const [gfsItmList, setGfsItmList] = useState(comnUtils.getGridData([]));

    /*
     * Code Resource
     * !== 사용할 Code 정의 ==!
     */
    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "OSC0144" }, // Fee Processing Status Code !== 처리상태코드 ==!
            { area: "comnCd", comnCd: "OSC0081" },
        ],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // LPCO Fee Form !== 수수료 조회 Form ==!
        lpcoFeeForm: useForm({
            defaultSchema: SF_SCHEMA_LPCO_FEE_FORM,
            defaultValues: {},
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        gfsItmList: useGrid({
            defaultSchema: SG_GFS_ITM_LIST,
        }),
    };
    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // View notification details in detail !== 고지 내역 상세 조회 ==!
        getFeeBllDtl: useFetch({
            api: (data) => APIS.getLpcoFeeDtl(uuid),
            enabled: !!uuid,
            onSuccess: (data) => {
                form.lpcoFeeForm.setValues({
                    ...data.lpcoFeeInfo.content,
                });

                if (data.lpcoFeeInfo.content.gfsItmList && data.lpcoFeeInfo.content.gfsItmList.length > 0) {
                    setVsdItms(true);
                    const filteredList = data.lpcoFeeInfo.content.gfsItmList.filter(
                        (item: any) => Number(item.bllItmTzsAmt) !== 0,
                    );
                    setGfsItmList(comnUtils.getGridData(filteredList));
                }
            },
            onError: (error) => {},
            showToast: true,
        }),
        getBillPrint: useFetch({
            api: (bllNo) => {
                return lpcoUtils.getBillPrint(bllNo);
            },
            onSuccess: (data) => {
                modal.openModal({
                    type: "pdf",
                    data: data,
                    thumbnail: true,
                    download: true,
                    print: true,
                });
            },
            onError: (error) => {
                modal.openModal({
                    content: "msg.osc.00015",
                });
            },
        }),
    };

    const render = {
        grid_gfsItmList: {
            head: {},
            cell: {},
            edit: {},
        },
    };

    /*
     * Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        form.lpcoFeeForm.setEditable(false);
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Layout>
                        <Layout.Left>
                            <Group.Title title={"T_FEE_INFO"} titleSize={1}></Group.Title>
                        </Layout.Left>
                    </Layout>

                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.lpcoFeeForm.schema.bllNo} />
                            <Group.Control {...form.lpcoFeeForm.schema.bllMgmtId} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.lpcoFeeForm.schema.appNm} />
                            <Group.Control {...form.lpcoFeeForm.schema.appNo} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.lpcoFeeForm.schema.currCd} />
                            <Group.Control {...form.lpcoFeeForm.schema.feeImpsTpCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.lpcoFeeForm.schema.bllAmt} />
                            <Group.Control {...form.lpcoFeeForm.schema.bllTzsAmt} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.lpcoFeeForm.schema.issDt} />
                            <Group.Control {...form.lpcoFeeForm.schema.xpirDt} />
                        </Group.Row>
                    </Group.Section>

                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.lpcoFeeForm.schema.paidAmt} />
                            <Group.Control {...form.lpcoFeeForm.schema.payDt} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.lpcoFeeForm.schema.bllSttsCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.lpcoFeeForm.schema.rmrk} controlSize={10} />
                        </Group.Row>
                    </Group.Section>

                    {vsdItms && (
                        <>
                            <Layout direction="row">
                                <Layout.Left>
                                    <Group.Title title={"T_ITM_LST"} titleSize={2}></Group.Title>
                                </Layout.Left>
                            </Layout>
                            <Grid {...grid.gfsItmList.grid} data={gfsItmList} render={render.grid_gfsItmList} />
                        </>
                    )}

                    <Layout direction="row">
                        <Layout.Right>
                            {/* <Button
                                variant="secondary"
                                onClick={() => {
                                    console.log(form.lpcoFeeForm.getValues());
                                    const bllCstmOfceCd = form.lpcoFeeForm.getValue("bllCstmOfceCd");
                                    const bllYy = form.lpcoFeeForm.getValue("bllYy");
                                    const bllTpCd = form.lpcoFeeForm.getValue("bllTpCd");
                                    const bllSrno = form.lpcoFeeForm.getValue("bllSrno");
                                    const bllDgr = form.lpcoFeeForm.getValue("bllDgr");
                                    const bllNo = `${bllCstmOfceCd}-${bllYy}-${bllTpCd}-${bllSrno}-${bllDgr}`;
                                    fetch.getBillPrint.fetch(bllNo);
                                }}
                            >
                                {t("B_PRNT_BLL")}
                            </Button> */}
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="list"
                        onClick={() => {
                            navigate(URLS.osci0205005q);
                        }}
                    />
                </Layout.Left>
            </Layout>
        </Page>
    );
};
